// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__LbEG7","links":"Footer_links__B1JjE"};